/** Public document URLs use the build base; API URLs retain their own prefix. */
export function adminHref(path: string, base = import.meta.env.BASE_URL): string {
  return `${base.replace(/\/$/, '')}/${path.replace(/^\//, '')}`
}

export function adminRoutePath(path: string, base = import.meta.env.BASE_URL): string {
  const prefix = base.replace(/\/$/, '')
  return prefix && path.startsWith(`${prefix}/`) ? path.slice(prefix.length) : path
}
